module.exports = __webpack_public_path__ + "static/img/14000748.7cf77a93.png";